<div
  *ngIf="tgaType; else noTgaType"
  [nbPopover]="popover"
  [nbPopoverTrigger]="'hover'"
  [nbPopoverPlacement]="'bottom'">
  {{tgaType.name}}
</div>

<ng-template #noTgaType>
  <div class="no-tga-type">kein TGA Typ</div>
</ng-template>

<ng-template #popover>
  <wr-tga-type-popover [tgaType]="tgaType" [disableLink]="disableLink"></wr-tga-type-popover>
</ng-template>
